'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const clsx = require('clsx');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const badge = "_badge_1xm4m_1";
const styles = {
	badge: badge
};

const Badge = ({ className, variant = "neutral-stronger", children }) => {
  return React__default.default.createElement("span", { className: clsx.clsx(styles.badge, className), "data-variant": variant, "data-zds": true }, children);
};

exports.Badge = Badge;
//# sourceMappingURL=Badge.cjs.js.map
